export var toasterTemplate = function(options, closeIconFunction) {
    var toasterDiv = document.createElement("div");
    toasterDiv.id = options.componentId + "-container";
    toasterDiv.classList.add("kmd-notifications__container");
    toasterDiv.style.zIndex = "1000";
    toasterDiv.style.maxWidth = "490px";
    var notificationDiv = document.createElement("div");
    notificationDiv.id = options.componentId;
    notificationDiv.classList.add("kmd-notification", "kmd-notification--".concat(options.type));
    toasterDiv.appendChild(notificationDiv);
    var messageDiv = document.createElement("div");
    messageDiv.classList.add("kmd-notification__message", "kmd-text--secondary", "custom-kmd-notification-msg");
    messageDiv.innerHTML = '<span class="kmd-text--primary">'.concat(options.title, "</span> ").concat(options.content);
    notificationDiv.appendChild(messageDiv);
    var closeDiv = document.createElement("div");
    closeDiv.classList.add("kmd-notification__close", "custom-kmd-notification__close");
    notificationDiv.appendChild(closeDiv);
    if (closeIconFunction) {
        closeDiv.onclick = closeIconFunction;
    }
    return toasterDiv;
};
